import { defineStore } from 'pinia'
import { ref } from 'vue'
import http from '@/utils/http'
import { getLocale } from '@/i18n'

export const useHelpStore = defineStore('help', () => {
  const helpContent = ref('')
  const loading = ref(false)

  async function fetchHelp(key: string) {
    loading.value = true
    helpContent.value = '' // Reset

    try {
      const locale = getLocale()
      // Note: http interceptor returns response.data directly, so response IS the data object
      const response = await http.get(`/api/v1/help/pages/${key}`, { params: { locale } }) as unknown as { content: string }
      helpContent.value = response.content
    } catch (error) {
      console.error('Failed to fetch help content:', error)
      // Leave empty, API should return default content
      helpContent.value = ''
    } finally {
      loading.value = false
    }
  }

  return { helpContent, loading, fetchHelp }
})
